module.exports = __webpack_public_path__ + "img/logo.78cb2e8f.svg";